import styled from "@emotion/styled"
import { PButton, PText } from "@porsche-design-system/components-react"
import { spacingStaticXl } from "@porsche-design-system/components-react/emotion"
import { useContext, useState } from "react"
import { FormattedMessage } from "react-intl"
import { ButtonGroup } from "src/components"
import { Modal } from "src/context/modal/Modal"
import { ModalContext } from "src/context/modal/ModalContext"
import type { ModalProps } from "src/context/modal/ModalProvider"
import { newsEditorMessages as messages } from "./newsEditor.messages"

interface NewsTransitionModalProps {
	confirmLabel: string
	heading: string
	message: string
	onConfirm: () => Promise<void>
}

export const NewsTransitionModal = ({ id, modalProps }: ModalProps<NewsTransitionModalProps>) => {
	const { hideModal } = useContext(ModalContext)
	const [isLoading, setIsLoading] = useState(false)

	const onCancel = () => hideModal(id)

	const onConfirm = async () => {
		if (isLoading) {
			return
		}
		setIsLoading(true)
		try {
			await modalProps.onConfirm()
		} finally {
			hideModal(id)
		}
	}

	return (
		<Modal
			id={id}
			heading={modalProps.heading}
			dismissButton={!isLoading}
			disableBackdropClick
			data-testid="news-transition-modal"
		>
			<ModalContent>
				<PText>{modalProps.message}</PText>
				<Actions>
					<ButtonGroup withoutMarginTop>
						<PButton
							data-testid="news-transition-modal-confirm-button"
							loading={isLoading}
							onClick={onConfirm}
						>
							{modalProps.confirmLabel}
						</PButton>
						<PButton
							data-testid="news-transition-modal-cancel-button"
							type="button"
							variant="secondary"
							disabled={isLoading}
							onClick={onCancel}
						>
							<FormattedMessage {...messages.modalCancel} />
						</PButton>
					</ButtonGroup>
				</Actions>
			</ModalContent>
		</Modal>
	)
}

const ModalContent = styled.div`
	max-width: 40rem;
`

const Actions = styled.div`
	margin-block-start: ${spacingStaticXl};
`
